import React, { Component } from 'react';
import { Button, Form } from 'react-bootstrap';
import axios from 'axios';
import ls from "local-storage";
import { Trans } from "react-i18next";   
import "../../../../config/i18n";
import { withTranslation } from "react-i18next";

class ChangeLanguage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            successMessage: '',
            selectedOption: localStorage.getItem('setlanguage'),
            api_url: localStorage.getItem('api_url'),
            user_details: '',
        };
        this.languagechange = this.languagechange.bind(this);
    }

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
        
        this.setState({
            selectedOption: ls.get('LangValue'),
        });
    }

    handleOptionChange = (changeEvent) => {
        this.setState({
            selectedOption: changeEvent.target.value
        });
    };

    languagechange = () => {
        const apiUrl = localStorage.getItem('api_url');
        var profile = new FormData();
        profile.append('setlanguage', this.state.selectedOption);
        profile.append('user_id',JSON.parse(localStorage.getItem('session_userid')));
        profile.append('language', 'en'); 

        axios({
            method: 'post',
            url: apiUrl+'websetlanguage',
            data: profile,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status !== "false") {
                const message = res.data.message;
                const setlanguage = res.data.setlanguage;
                this.setState({
                    selectedOption: setlanguage,
                    successMessage: message,
                    suc_cls: 'successMsg floatingAlerts1'
                });
                localStorage.setItem('setlanguage',this.state.selectedOption);
                localStorage.setItem('language',this.state.selectedOption);
                setTimeout(() => {
                    this.setState({
                        suc_cls: 'successMsghide'
                    });
                }, 5000);
                const { i18n } = this.props;
                if (i18n && i18n.changeLanguage) {
                    i18n.changeLanguage(setlanguage);
                    ls.set('LangKeySet', setlanguage);
                    ls.set('LangValue', setlanguage);
                    window.location.reload();
                } else {
                    console.log('i18n or changeLanguage method is not defined');
                }
            } else {
                console.log("Err");
            }    
        }).catch(error => {
            console.log("Error: ", error);
        });
    }

    render() {
        const checkedRadioStyle = {
            color: '#fff',
        };

        return (
            <div className=''>
                <div className='whole_information'>
                    {this.state.successMessage && (
                        <div className={this.state.suc_cls}>
                            {this.state.successMessage}
                        </div>
                    )}
                </div>
                <div className='setting_tab_title'>
                    <h4><Trans i18nKey="Change Language">Change Language</Trans></h4>
                </div>
                <div className='language_form'>
                    {/* English */}
                    <Form.Group controlId="formPlaintextEmail" className={`language_formgroup ${this.state.selectedOption === "en" ? 'common_language' : ''}`}>
                        <Form.Check.Label htmlFor="englishRadio">
                            <span style={this.state.selectedOption === "en" ? checkedRadioStyle : null}><Trans i18nKey="English">English</Trans></span>
                        </Form.Check.Label>
                        <Form.Check
                            type="radio"
                            id="englishRadio"
                            name="radioGroup"
                            value="en"
                            checked={this.state.selectedOption === "en"}
                            onChange={this.handleOptionChange}
                        />
                    </Form.Group>

                    {/* French */}
                    <Form.Group controlId="formPlaintextEmail" className={`language_formgroup ${this.state.selectedOption === "fr" ? 'common_language' : ''}`}>
                        <Form.Check.Label htmlFor="frenchRadio">
                            <span style={this.state.selectedOption === "fr" ? checkedRadioStyle : null}><Trans i18nKey="French">French</Trans></span>
                        </Form.Check.Label>
                        <Form.Check
                            type="radio"
                            id="frenchRadio"
                            name="radioGroup"
                            value="fr"
                            checked={this.state.selectedOption === "fr"}
                            onChange={this.handleOptionChange}
                        />
                    </Form.Group>

                    {/* Arabic */}
                    <Form.Group controlId="formPlaintextEmail" className={`language_formgroup ${this.state.selectedOption === "ar" ? 'common_language' : ''}`}>
                        <Form.Check.Label htmlFor="arabicRadio">
                            <span style={this.state.selectedOption === "ar" ? checkedRadioStyle : null}><Trans i18nKey="Arabic">Arabic</Trans></span>
                        </Form.Check.Label>
                        <Form.Check
                            type="radio"
                            id="arabicRadio"
                            name="radioGroup"
                            value="ar"
                            checked={this.state.selectedOption === "ar"}
                            onChange={this.handleOptionChange}
                        />
                    </Form.Group>

                    {/* Amharic */}
                    <Form.Group controlId="formPlaintextEmail" className={`language_formgroup ${this.state.selectedOption === "am" ? 'common_language' : ''}`}>
                        <Form.Check.Label htmlFor="amharicRadio">
                            <span style={this.state.selectedOption === "am" ? checkedRadioStyle : null}><Trans i18nKey="Amharic">Amharic</Trans></span>
                        </Form.Check.Label>
                        <Form.Check
                            type="radio"
                            id="amharicRadio"
                            name="radioGroup"
                            value="am"
                            checked={this.state.selectedOption === "am"}
                            onChange={this.handleOptionChange}
                        />
                    </Form.Group>

                    {/* Tigrinya */}
                    <Form.Group controlId="formPlaintextEmail" className={`language_formgroup ${this.state.selectedOption === "ti" ? 'common_language' : ''}`}>
                        <Form.Check.Label htmlFor="tigrinyaRadio">
                            <span style={this.state.selectedOption === "ti" ? checkedRadioStyle : null}><Trans i18nKey="Tigrinya">Tigrinya</Trans></span>
                        </Form.Check.Label>
                        <Form.Check
                            type="radio"
                            id="tigrinyaRadio"
                            name="radioGroup"
                            value="ti"
                            checked={this.state.selectedOption === "ti"}
                            onChange={this.handleOptionChange}
                        />
                    </Form.Group>

                    {/* Oromo */}
                    <Form.Group controlId="formPlaintextEmail" className={`language_formgroup ${this.state.selectedOption === "om" ? 'common_language' : ''}`}>
                        <Form.Check.Label htmlFor="oromoRadio">
                            <span style={this.state.selectedOption === "om" ? checkedRadioStyle : null}><Trans i18nKey="Oromo">Oromo</Trans></span>
                        </Form.Check.Label>
                        <Form.Check
                            type="radio"
                            id="oromoRadio"
                            name="radioGroup"
                            value="om"
                            checked={this.state.selectedOption === "om"}
                            onChange={this.handleOptionChange}
                        />
                    </Form.Group>

                    {/* Hebrew */}
                    <Form.Group controlId="formPlaintextEmail" className={`language_formgroup ${this.state.selectedOption === "he" ? 'common_language' : ''}`}>
                        <Form.Check.Label htmlFor="hebrewRadio">
                            <span style={this.state.selectedOption === "he" ? checkedRadioStyle : null}><Trans i18nKey="Hebrew">Hebrew</Trans></span>
                        </Form.Check.Label>
                        <Form.Check
                            type="radio"
                            id="hebrewRadio"
                            name="radioGroup"
                            value="he"
                            checked={this.state.selectedOption === "he"}
                            onChange={this.handleOptionChange}
                        />
                    </Form.Group>

                    {/* Somali */}
                    <Form.Group controlId="formPlaintextEmail" className={`language_formgroup ${this.state.selectedOption === "so" ? 'common_language' : ''}`}>
                        <Form.Check.Label htmlFor="somaliRadio">
                            <span style={this.state.selectedOption === "so" ? checkedRadioStyle : null}><Trans i18nKey="Somali">Somali</Trans></span>
                        </Form.Check.Label>
                        <Form.Check
                            type="radio"
                            id="somaliRadio"
                            name="radioGroup"
                            value="so"
                            checked={this.state.selectedOption === "so"}
                            onChange={this.handleOptionChange}
                        />
                    </Form.Group>
                </div>
                <div className='chang_pwd_margin'>
                    <Button className='button_primary' onClick={this.languagechange}><Trans i18nKey="SAVE">SAVE</Trans></Button>
                </div>
            </div>
        );
    }
}

export default withTranslation("translations")(ChangeLanguage);
